'use client';

import { useTranslations } from 'next-intl';
import { VStack } from '@terra/ui-styled-system';
import { BodyDefault, MetaDefault } from '../../../../../components/typography';
import { MarkdownPreview } from '../../../../markdown-preview';
import { SignalSelector } from './SignalSelector';
import type { AttackerToolInput } from './types';

type AttackerCardProps = {
  data: AttackerToolInput;
  variant?: 'compact' | 'detailed';
};

export function AttackerCard({ data }: AttackerCardProps) {
  const t = useTranslations('designSystem.chat.attackerTool');

  return (
    <VStack alignItems="stretch" gap={2} width="100%">
      {data.userAttackPrompt ? (
        <MarkdownPreview source={data.userAttackPrompt} compact fontSize={14} />
      ) : data.signalId ? (
        <SignalSelector selectedSignalId={data.signalId} readOnly flat />
      ) : (
        <MetaDefault color="fg.error">{t('missingSignalId')}</MetaDefault>
      )}
      {data.userNotes ? (
        <BodyDefault color="fg.muted">{data.userNotes}</BodyDefault>
      ) : null}
    </VStack>
  );
}
